import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { TfService } from './tf-service.service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { SkipPublicPageService } from '../Theme/shared/service/skip-public-page/skip-public-page.service';

@Injectable({
  providedIn: 'root'
})
export class PreventPublicAccessGuard implements CanActivate {

  constructor(
    private router: Router,
    private tfService: TfService,
    private skipPublicPageService: SkipPublicPageService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.tfService.checkAuthStatus().pipe(
      take(1),
      switchMap((authInfo) => {
        const isLoggedIn = authInfo?.isAuthenticated;

        if (isLoggedIn) {
          const userGroups = this.tfService.normalizeUserGroups(authInfo?.userGroups);

          if (userGroups.includes('admin')) {
            this.router.navigateByUrl('/admin/cf-dashboard');
          } else if (this.tfService.isCustomerPortalUser(userGroups)) {
            this.router.navigateByUrl(this.tfService.getDefaultCustomerDashboardUrlForGroups(userGroups));
          } else {
            this.router.navigateByUrl('/customer/CFProduct/product-view');
          }

          return of(false);
        }

        // Country from visitor public IP → GET /CP/skip-public-page/resolve/?country_code=XX
        return this.skipPublicPageService.canDisplayHomePageForVisitorIp().pipe(
          map((canDisplayHome) => {
            if (!canDisplayHome) {
              this.router.navigateByUrl('/auth/signin');
              return false;
            }

            return true;
          })
        );
      }),
      catchError(() => of(true))
    );
  }
}
